import React from 'react';
import { FormControl } from '@mui/material';

import { StyledTextField } from 'components/Input/styles';
import { useOptimistic } from 'hooks/useOptimistic';

import { ProtectorTypeTextProps } from '../types';

export const CustomTextInputField = ({
  value,
  description,
  onChange,
  multiline,
  minRows,
  requiredNotFilled,
  onKeyDown,
  inputProps,
  errorMessage,
}: ProtectorTypeTextProps & {
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  errorMessage?: string;
}): React.ReactElement => {
  // Use optimistic updates to prevent backtracking from stale debounced updates
  const [input, setInput] = useOptimistic(value as string);

  return (
    <FormControl fullWidth>
      <StyledTextField
        id={`${multiline ? 'long' : 'short'}-text-field`}
        placeholder={description}
        value={input}
        onChange={(event) => {
          const newValue = event.target.value;
          setInput(newValue);
          onChange(newValue);
        }}
        variant="outlined"
        multiline={multiline}
        minRows={minRows ?? (description === 'Description' || multiline ? 5 : 1)}
        maxRows={description === 'Description' || multiline ? 20 : undefined}
        onFocus={(event) => {
          const { length } = input as string;
          event.target.setSelectionRange(length, length);
        }}
        error={requiredNotFilled}
        helperText={errorMessage}
        onKeyDown={onKeyDown}
        inputProps={inputProps}
      />
    </FormControl>
  );
};

export default CustomTextInputField;
